// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__178PH","colMin":"styles_colMin__3X5_S"};